export var KeycloakEndpoint;
(function (KeycloakEndpoint) {
    KeycloakEndpoint["TOKEN"] = "protocol/openid-connect/token";
    KeycloakEndpoint["LOGOUT"] = "protocol/openid-connect/logout";
    KeycloakEndpoint["AUTH"] = "protocol/openid-connect/auth";
    KeycloakEndpoint["PASSWORD"] = "user-profile/credentials/password";
    KeycloakEndpoint["PHONE_NUMBER"] = "user-profile/phone-number";
    KeycloakEndpoint["ADDITIONAL_PHONE_NUMBER"] = "user-profile/additional-phone-number";
    KeycloakEndpoint["PHONE_NUMBER_RESEND_CHALLENGE"] = "user-profile/phone-number/resend-challenge";
    KeycloakEndpoint["ADDITIONAL_PHONE_NUMBER_RESEND_CHALLENGE"] = "user-profile/additional-phone-number/resend-challenge";
    KeycloakEndpoint["PHONE_NUMBER_VERIFY_CHALLENGE"] = "user-profile/phone-number/verify-challenge";
    KeycloakEndpoint["ADDITIONAL_PHONE_NUMBER_VERIFY_CHALLENGE"] = "user-profile/additional-phone-number/verify-challenge";
    KeycloakEndpoint["FIREBASE_TOKEN"] = "firebase/generate-token";
    KeycloakEndpoint["EMAIL_ADD_UNVERIFIED"] = "user-profile/email/add-unverified";
    KeycloakEndpoint["EMAIL_GENERATE_CHALLENGE"] = "user-profile/email/generate-challenge";
    KeycloakEndpoint["EMAIL_RESEND_CHALLENGE"] = "user-profile/email/resend-challenge";
    KeycloakEndpoint["EMAIL_VERIFY_CHALLENGE"] = "user-profile/email/verify-challenge";
    KeycloakEndpoint["USER_ATTRIBUTES"] = "user-profile/attributes";
    KeycloakEndpoint["LINK_IDENTITY_PROVIDER"] = "identity-provider/link-provider";
    KeycloakEndpoint["UNLINK_IDENTITY_PROVIDER"] = "identity-provider/unlink-provider";
    KeycloakEndpoint["PASSWORDLESS_LOGIN_GENERATE_EMAIL_CHALLENGE"] = "passwordless-login/email/generate-challenge";
    KeycloakEndpoint["PASSWORDLESS_LOGIN_RESEND_EMAIL_CHALLENGE"] = "passwordless-login/email/resend-challenge";
    KeycloakEndpoint["PASSWORDLESS_LOGIN_GENERATE_PHONE_NUMBER_CHALLENGE"] = "passwordless-login/phone-number/generate-challenge";
    KeycloakEndpoint["PASSWORDLESS_LOGIN_RESEND_PHONE_NUMBER_CHALLENGE"] = "passwordless-login/phone-number/resend-challenge";
    KeycloakEndpoint["DEACTIVATE_USER"] = "user-profile/deactivate-user";
    KeycloakEndpoint["EMAIL_RESERVE_USER"] = "user-reservation/email/create-reservation";
    KeycloakEndpoint["USER_INFO"] = "protocol/openid-connect/userinfo";
})(KeycloakEndpoint || (KeycloakEndpoint = {}));
export var KeycloakAPIGrantType;
(function (KeycloakAPIGrantType) {
    KeycloakAPIGrantType["PASSWORD"] = "password";
    KeycloakAPIGrantType["REFRESH_TOKEN"] = "refresh_token";
    KeycloakAPIGrantType["AUTHORIZATION_CODE"] = "authorization_code";
    KeycloakAPIGrantType["TOKEN_EXCHANGE"] = "urn:ietf:params:oauth:grant-type:token-exchange";
})(KeycloakAPIGrantType || (KeycloakAPIGrantType = {}));
export var OAuthTokenTypeIdentifier;
(function (OAuthTokenTypeIdentifier) {
    OAuthTokenTypeIdentifier["ACCESS_TOKEN"] = "urn:ietf:params:oauth:token-type:access_token";
    OAuthTokenTypeIdentifier["ID_TOKEN"] = "urn:ietf:params:oauth:token-type:id_token";
    OAuthTokenTypeIdentifier["REFRESH_TOKEN"] = "urn:ietf:params:oauth:token-type:refresh_token";
})(OAuthTokenTypeIdentifier || (OAuthTokenTypeIdentifier = {}));
export var KeycloakMedium;
(function (KeycloakMedium) {
    KeycloakMedium["EMAIL"] = "email";
    KeycloakMedium["PHONE"] = "phone";
})(KeycloakMedium || (KeycloakMedium = {}));
export var KeycloakAuthMethod;
(function (KeycloakAuthMethod) {
    KeycloakAuthMethod["EMAIL_CODE"] = "email_code";
    KeycloakAuthMethod["EMAIL_LINK"] = "email_link";
    KeycloakAuthMethod["EMAIL_PASSWORD"] = "email_password";
    KeycloakAuthMethod["PHONE_CODE"] = "phone_code";
    KeycloakAuthMethod["PHONE_PASSWORD"] = "phone_password";
    KeycloakAuthMethod["AUTHORIZATION_CODE"] = "authorization_code";
    KeycloakAuthMethod["TOKEN_EXCHANGE"] = "token_exchange";
})(KeycloakAuthMethod || (KeycloakAuthMethod = {}));
export var KeycloakEmailChallengeType;
(function (KeycloakEmailChallengeType) {
    KeycloakEmailChallengeType["CODE"] = "code";
    KeycloakEmailChallengeType["LINK"] = "link";
})(KeycloakEmailChallengeType || (KeycloakEmailChallengeType = {}));
export var KeycloakOtpAction;
(function (KeycloakOtpAction) {
    KeycloakOtpAction["GENERATE"] = "generate";
    KeycloakOtpAction["RESEND"] = "resend";
    KeycloakOtpAction["VERIFY"] = "verify";
})(KeycloakOtpAction || (KeycloakOtpAction = {}));
export var KeycloakChannel;
(function (KeycloakChannel) {
    KeycloakChannel["EMAIL"] = "email";
    KeycloakChannel["SMS"] = "sms";
    KeycloakChannel["CALL"] = "call";
})(KeycloakChannel || (KeycloakChannel = {}));
export var KeycloakIdentityProvider;
(function (KeycloakIdentityProvider) {
    KeycloakIdentityProvider["GOOGLE"] = "google";
    KeycloakIdentityProvider["FACEBOOK"] = "facebook";
    KeycloakIdentityProvider["HUAWEI"] = "huawei-id";
})(KeycloakIdentityProvider || (KeycloakIdentityProvider = {}));
export var KeycloakAPIErrorCode;
(function (KeycloakAPIErrorCode) {
    KeycloakAPIErrorCode["PASSWORD_REQUIRED"] = "password_required";
    KeycloakAPIErrorCode["PASSWORD_INVALID"] = "password_validation_failed";
    KeycloakAPIErrorCode["OLD_PASSWORD_INVALID"] = "old_password_invalid";
    KeycloakAPIErrorCode["OLD_PASSWORD_REQUIRED"] = "old_password_required";
    KeycloakAPIErrorCode["PHONE_NUMBER_ALREADY_IN_USE"] = "phone_number_in_use";
    KeycloakAPIErrorCode["PHONE_NUMBER_INVALID"] = "phone_number_validation";
    KeycloakAPIErrorCode["PHONE_NUMBER_REQUIRED"] = "phone_number_missing";
    KeycloakAPIErrorCode["MEDIUM_INVALID"] = "medium_invalid";
    KeycloakAPIErrorCode["MEDIUM_REQUIRED"] = "medium_missing";
    KeycloakAPIErrorCode["CODE_EXPIRED"] = "code_expired";
    KeycloakAPIErrorCode["CODE_TOKEN_INVALID"] = "token_invalid";
    KeycloakAPIErrorCode["CODE_TOKEN_MISSING"] = "token_missing";
    KeycloakAPIErrorCode["CODE_REQUIRED"] = "code_missing";
    KeycloakAPIErrorCode["CODE_INVALID"] = "code_invalid";
    KeycloakAPIErrorCode["CODE_SEND_FAILED"] = "code_send_failed";
    KeycloakAPIErrorCode["EMAIL_ALREADY_IN_USE"] = "email_in_use";
    KeycloakAPIErrorCode["EMAIL_REQUIRED"] = "email_missing";
    KeycloakAPIErrorCode["EMAIL_INVALID"] = "invalid_email";
    KeycloakAPIErrorCode["EMAIL_ALREADY_SET"] = "email_already_set";
    KeycloakAPIErrorCode["ATTRIBUTES_INVALID"] = "attributeValidationError";
    KeycloakAPIErrorCode["INVALID_REQUEST"] = "invalid_request";
    KeycloakAPIErrorCode["USER_DISABLED"] = "user_disabled";
    KeycloakAPIErrorCode["CLIENT_INVALID"] = "invalid_client";
    KeycloakAPIErrorCode["CHALLENGE_TYPE_INVALID"] = "invalid_challenge_type";
})(KeycloakAPIErrorCode || (KeycloakAPIErrorCode = {}));
